import { UCSDK } from "../external";

export default {
  UCSDKService: {
    getTopicAsync: UCSDK.getTopicAsync,
    getTopic: UCSDK.getTopic,
    getB2CCookieContainerIdAsync: UCSDK.getB2CCookieContainerIdAsync,
    findIfIsUserEligibleAsync: UCSDK.findIfIsUserEligibleAsync,
    getActiveAbTestFeaturesAsync: UCSDK.getActiveAbTestFeaturesAsync,
    checkEnvAuthPasswordAsync: UCSDK.checkEnvAuthPasswordAsync,
    clearNativeDataStore: UCSDK.clearNativeDataStore,
    updateNativeDataStore: UCSDK.updateNativeDataStore
  }
};
